import { render, staticRenderFns } from "./Sss.vue?vue&type=template&id=5db5e723&scoped=true&"
import script from "./Sss.vue?vue&type=script&lang=js&"
export * from "./Sss.vue?vue&type=script&lang=js&"
import style0 from "./Sss.vue?vue&type=style&index=0&id=5db5e723&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db5e723",
  null
  
)

export default component.exports